import axios from "axios";

export class Cie10ListService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `https://rda-503334291954.us-east1.run.app/cie10-searcher`;
  }

  async normalSearch(collection: string, keyWord: string) {
    return (
      await axios.get(`${this.baseUrl}/searchItem`, {
        params: { collection, keyWord }
      })
    ).data;
  }

  async cie10Search(query: string) {
    return (
      await axios.get(this.baseUrl, {
        params: { q: query, lang: "es" }
      })
    ).data;
  }
}
